export default __webpack_public_path__ + "static/media/billingIcon.805da0d4.svg";